/** Inactivity before the automatic sign-out (unchanged: 1 hour). */
export const SESSION_IDLE_SIGN_OUT_MS = 60 * 60 * 1000;

/** The warning shows this long before the sign-out (Roadmap 1800). */
export const SESSION_WARNING_MS = 3 * 60 * 1000;

/** "2:59", "0:05"; never negative. */
export const formatCountdown = (milliseconds: number) => {
  const totalSeconds = Math.max(0, Math.ceil(milliseconds / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes}:${String(seconds).padStart(2, "0")}`;
};
